<template>
<div>
<!-- Start Top Parallax Image -->
  <v-parallax
    dark
    src="/sumo/images/parallax/plax1.jpg"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        class='hidden-sm-and-down align-end'
        :lg='3'
        :md='5'
      >
        <v-img
          lazy-src="/sumo/images/lazyload.jpg"
          max-height="524"
          max-width="333"
          src="/sumo/images/loginhand.png"
        ></v-img>
      </v-col>
      <v-col
        class="text-start"
        :lg='5'
        :md='5'
        :sm='10'
        :xs='10'
        border
      >
        <h3 class='display-1 font-weight-medium mb-2'>
          Summit Mobile: SuMo
        </h3>
        <blockquote>
          Are your technicians spending too much time walking from their repair bay to workstations losing precious time and productivity
          in the process? Houston Digital presents Summit Mobile: SuMo for Android and iOS devices. SuMo is a wonderful time clock and productivity
          tool for the SummitCRS technician available as a paid add-on for SummitCRS. Contact SummitCRS to add SuMo to your shop today!
        </blockquote>
        <div class='mt-2'>
          <v-btn class='primary mr-4' to='/features'>Features</v-btn>
          <v-btn class='success' href='#contact'>Get Started</v-btn>
        </div>

      </v-col>
    </v-row>
  </v-parallax>
<!-- End Parallax  -->

<!-- Begin Benefit Boxes -->
  <v-layout row wrap justify-center align-center ma-5 text-center>
    <v-flex xs12 sm10 md3 lg2 ma-1 :key="index" v-for="(channel, index) in channels">
      <v-layout row wrap align-center justify-center ma-1>
        <v-flex xs12 text-xs-center>
          <v-icon size="100" color='blue-grey darken-2'>{{ channel.icon }}</v-icon>

        </v-flex>
        <v-flex xs10 sm12>
          <P class="headline">{{ channel.headline}}</p>
        </v-flex>
        <v-flex xs10 sm12>
          {{ channel.desc }}
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
<!-- End Benefit Boxes -->

<!-- Start Android iOS Parallax -->
  <v-parallax
    dark
    src="/sumo/images/parallax/plax3.jpg"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        class="text-center"
        cols="12"
      >
        <v-layout ma-5 row wrap justify-center align-center pa-5>
          <v-flex sm12 md10 lg4 pa-5 order-xs2>
            <p align='center'>
             <a href="https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1235153348&mt=8">
               <img src="images/app-store-badge.svg" width="200px" height="auto"/>
             </a>
             <a href="https://play.google.com/store/apps/details?id=com.embarcadero.SuMo">
               <img src="images/google-play.png" width="auto" height="60">
             </a>
           </p>
            <h3 class='display-1 font-weight-medium mb-2'>Android and iOS Mobile Support</h3>
            <blockquote>
              With SuMo you are no longer tied to a desk, keep production moving where ever you or your staff are.
              SuMo is ready to be installed directly to your mobile device with Android or iOS.
            </blockquote>
          </v-flex>
        </v-layout>
      </v-col>
    </v-row>
  </v-parallax>
<!-- End Android iOS Parallax -->

<!-- Start Video Embeds -->
  <v-layout ma-5 pa-5 row wrap justify-center align-center>
    <v-flex hidden-md-and-down sm10 md4 lg5 xl4 pa-5>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/quXMVEaCEjw" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </v-flex>
    <v-flex md10 lg5 xl4 pa-5>
      <h1 class='mb-2'>Mobile Time Clock</h1>
        <h3 class='font-weight-light'>
          SuMo takes the time clock of TechCentral and puts it in the hands of your technician. Your tech can clock in and out
          of ROs or create non-RO punches, creating job costs on each repair order for both hourly and flat rate technicians.
          Check out <a href='https://www.youtube.com/embed/quXMVEaCEjw'>this video</a> that walks us through the capabilities of SuMo's time clock.
        </h3>
    </v-flex>
  </v-layout>
  <v-divider class='hidden-md-and-up'></v-divider>
  <v-layout ma-5 pa-5 row wrap justify-center align-center>
    <v-flex md10 lg5 xl4 pa-5 order-xs2 order-md1>
      <h1 class='mb-2'>Android and iOS Image Support</h1>
      <h3 class='font-weight-light'>
        Looking for an Android/iOS app that can send images to Summit? <a href='https://www.youtube.com/embed/RJqjQcvTBCM'>Check out</a> SuMo, a new product from SummitCRS that does just that
        and much more. Not only is imaging made easy but your techs gain a mobile time clock and production tool in their pocket! Contact
        Summit support to add SuMo today!
      </h3>
    </v-flex>
    <v-flex  hidden-md-and-down sm10 md4 lg5 xl4 pa-5 order-sm1>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/RJqjQcvTBCM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </v-flex>
  </v-layout>
  <v-divider class='hidden-md-and-up'></v-divider>
  <v-layout ma-5 row wrap justify-center align-center pa-5>
    <v-flex  hidden-md-and-down sm10 md4 lg5 xl4 pa-5>
      <iframe width="560" height="315" src="https://www.youtube.com/embed/pQi-slkRwrA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </v-flex>
    <v-flex md10 lg5 xl4 pa-5>
      <h1 class='mb-2'>Production Management Tools</h1>
        <h3 class='font-weight-light'>
          Check out <a href='https://www.youtube.com/embed/pQi-slkRwrA'>this video</a> that highlights how Summit Mobile (SuMo) can help improve production throughout your shop.
          See additional manager functionality like the ability to create an RO with SuMo as well as gain access to the
          tech status screen to see what each technician in the shop is working on.
        </h3>
    </v-flex>
  </v-layout>
<!-- End Video Embeds -->

</div>
</template>

<script>
  export default {
    data() {
      return{
        channels: [
          {
            headline: 'Improve Cycle Time',
            desc: 'With the power of time clock in the palm of their hands, users have quick and easy access to update repair status in real time.',
            icon: 'mdi-timer-outline'
          },
          {
            headline: 'Production Visibility',
            desc: 'Users can easily view departments and the jobs within. The Technician Status screen provides visibility into each tech\'s current status.',
            icon: 'mdi-eye-outline'
          },
          {
            headline: 'Promote Accountability',
            desc: 'Department Checklist items require users to acknowledge all items as complete before moving the vehicle and triggering Auto Flags.',
            icon: 'mdi-format-list-checks'
          },
          {
            headline: 'Improved Job Costing',
            desc: 'With instant access to a time clock, create labor costs based on punches for hourly or flag labor for flat rate techs.',
            icon: 'mdi-bullseye-arrow '
          },
          {
            headline: 'Image Capture',
            desc: 'Capture images and upload directly to SummitCRS: Mediapoint Images to utilize your devices camera and WiFi.',
            icon: 'mdi-camera-outline'
          },

        ],
      }
    }
  }
  </script>
